/* eslint-disable indent */

import { Component } from '@verndale/core';
import MicroModal from 'micromodal';
import { constEvent } from '../utils/constants';
import { dispatchGenericEvent } from '../utils/dispatch-events';
import axios from 'axios';

class Module extends Component {
  setupDefaults() {
    this.id = this.el._$('.modal').id;
    this.dom = {
      $modalSlide: this.el._$('.modal'),
      $closeButton: this.el._$('.modal__close'),
      $overlay: this.el._$('.modal__overlay'),
      $modal: this.el._$('.modal__container'),
      $product: this.el._$('.modal-cart__product'),
      $requiredProductsContainer: this.el._$('.product-listing'),
      $requiredProducts: this.el._$('.swiper-wrapper'),
      $swiperContainer: this.el._$('.swiper-container'),
      $loaderWrapper: this.el._$('.modal-cart__loader-wrapper')
    };
    this.config = this.el.dataset;
    this.templates = {};
    this.product = '';
    this.requiredItems = [];
    this.IsHepatocyte = false;
    this.atccNumber = '';

    // Temporarily disabling add to list for this release
    this.templates.addToList = () => '';
    this.templates.addToList = id => `
       <button data-product-id="${id}" class="btn btn--flat btn--tag-icon">
         <span>${this.config.labelAtl}</span>
       </button>
     `;

    this.templates.price = (oldPrice, currentPrice, label) => `
      <div class="product-pricing">
        <span class="product-pricing__label">${label}: </span>
        ${
          oldPrice
            ? `<span class="product-pricing__old-price">${oldPrice}</span>`
            : ''
        }
        ${
          currentPrice
            ? `<span class="product-pricing__current-price">${currentPrice}</span>`
            : ''
        }
      </div>
    `;

    this.templates.product = item => `
      <div class="modal-cart__product-details">
        <h3 class="modal-cart__product-name">
          <a href="${item.url}">${item.name}</a>
        </h3>
        <p class="modal-cart__atcc-no">${item.atccNumber}</p>
      </div>
      <div class="modal-cart__checkout-block">
        ${this.templates.price(
          item.prettyOldPrice,
          item.prettyPrice,
          item.priceLabel
        )}
        <p class="modal-cart__product-quantity">
          ${this.config.labelQuantity}: ${item.quantity}
        </p>
        <button class="btn btn--primary modal-cart__product-cta modal-cart__product-cta--continue">
          ${this.config.labelContinue}
        </button>
        <a href="${this.config.checkoutUrl}"
          class="btn btn--primary modal-cart__product-cta">
          ${this.config.labelCheckout}
        </a>
      </div>
    `;

    this.templates.productHept = item => `
    <div class="modal-cart__product-details lot-info-modal">
    ${item.map(product => `
      <div class="item">
        <h3 class="modal-cart__product-name">
        <a href="${product.url}">${product.name}</a>
        </h3>
        <h3 class="modal-cart__product-lot-num">
        ${this.config.labelLot} ${product.lotNumber}
        </h3>
        <p class="modal-cart__atcc-no"><span>${product.atccNumber}</span> <span>${this.config.labelQuantity}: ${product.quantity}</span></p>
      </div>
    `).join('')}
    </div>
    <div class="modal-cart__checkout-block">
      ${this.templates.price(
        item[0].prettyOldPrice,
        item[0].prettyPrice,
        item[0].priceLabel
      )}
      <p class="modal-cart__product-quantity">
        ${this.config.labelQuantity}: ${item.reduce((accumulator, currentItem) => accumulator + currentItem.quantity, 0)}
      </p>
      <button class="btn btn--primary modal-cart__product-cta modal-cart__product-cta--continue">
        ${this.config.labelContinue}
      </button>
      <a href="${this.config.checkoutUrl}"
        class="btn btn--primary modal-cart__product-cta">
        ${this.config.labelCheckout}
      </a>
    </div>
  `;

    this.templates.atc = item => `
      <div class="product-listing__info-wrapper">
        ${this.templates.price(
          item.prettyOldPrice,
          item.prettyPrice,
          item.priceLabel
        )}
      </div>
      <form novalidate action="${this.config.atcEndpoint}" 
        class="product-listing__form">
        <div class="product-listing__atc-wrapper">
          <div class="field-wrapper">
            <label class="field__label">${this.config.labelQuantity}</label>
            <div class="field__input-wrapper">
              <input type="hidden" name="product_id" value="${item.atccNumber}">
              <input required data-pristine-required-message="${
                this.config.labelError
              }" name="quantity" min="1" class="field__input" type="text">
            </div>
          </div>

          <div class="product-listing__atc">
            <button type="submit" class="btn btn--primary btn--cart-icon">
              <span>${this.config.labelAtc}</span>
            </button>
          </div>
        </div>

        <span class="product-listing__message field__msg--error"></span>

        <div class="product-listing__atl-wrapper">
          ${this.templates.addToList(item.id)}
        </div>
      </form>
    `;

    this.templates.misstion = item => `
       <div class="product-listing__no-atc">
        <div class="product-listing__no-atc-info">
          <span>${this.config.labelMissionTitle}</span><br>
          <a href="${this.config.missionUrl}"
            class="link link--primary link--with-arrow">
            ${this.config.labelMissionCta}
          </a>
        </div>
        <div class="product-listing__no-atc-cta-wrapper">
          <a href="${item.url}" class="btn btn--primary">
            <span>${this.config.labelMissionCta}</span>
          </a>
          ${this.templates.addToList(item.id)}
        </div>
      </div>
    `;

    this.templates.distributor = item => `
      <div class="product-listing__no-atc-info">
        <span>${this.config.labelDistributor}</span>
      </div>
      <div class="product-listing__no-atc-cta-wrapper">
        <a href="${this.config.distributorUrl}" class="btn btn--primary">
          <span>${this.config.labelDistributorCta}</span>
        </a>
        ${this.templates.addToList(item.id)}
      </div>
    `;

    this.templates.requiredProduct = item => `
      <div class="product-listing__item swiper-slide">
        <h3 class="product-listing__product-name">
          <a href="${item.url}">${item.name}</a>
        </h3>
        <p class="product-listing__product-no">${item.atccNumber}</p>
        <div class="product-listing__details">
          ${
            !item.isMission && !item.isDistributor
              ? this.templates.atc(item)
              : ''
          }
          ${item.isMission ? this.templates.misstion(item) : ''}
          ${item.isDistributor ? this.templates.distributor(item) : ''}
        </div>
      </div>
    `;
  }

  addListeners() {
    const { $closeButton, $overlay, $modal } = this.dom;
    document._on(constEvent.ADDED_TO_CART, this.openModal.bind(this));
    if (window.location.href.indexOf('search') === -1) {
      document._on(constEvent.ADDED_TO_CART_HEPATOCYTE, this.openModal.bind(this));
    }
    $closeButton._on('click', this.closeModal.bind(this));
    $overlay._on('click', this.closeModal.bind(this));
    $modal._on('click', this.modalClick.bind(this));
  }

  openModal(e) {
    const { $requiredProductsContainer, $swiperContainer } = this.dom;

    $requiredProductsContainer.style.display = 'none';
    if ($swiperContainer) $swiperContainer.style.display = 'none';

    const cart = e?.detail?.cart || {};
    if (!cart) return;

    this.product = cart?.currentItem;
    this.IsHepatocyte = cart?.IsHepatocyte;
    if (this.IsHepatocyte){
      this.atccNumber = this.product[0]?.atccNumber;
      this.renderHeptProduct()
    } else {
      this.atccNumber = this.product?.atccNumber;
      this.renderProduct();
    }

    this.dom.$modal
      ._$('.modal-cart__product-cta--continue')
      ._on('click', this.closeModal.bind(this));

    MicroModal.show(this.id, {
      onShow: () =>
        this.loadRequiredItems(
          cart?.requiredItems || false,
          this.atccNumber || ''
        )
    });
  }

  closeModal(e) {
    e.preventDefault();
    e.stopPropagation();
    const { $modalSlide } = this.dom;

    if (this.id) {
      MicroModal.close(this.id);
      $modalSlide.classList.remove('is-open');
    }
  }

  modalClick(e) {
    e.stopPropagation();
  }

  renderProduct() {
    this.dom.$product.innerHTML = this.templates.product(this.product);
  }

  renderHeptProduct(){
    this.dom.$product.innerHTML = this.templates.productHept(this.product);
  }

  loadRequiredItems(hasRequiredItems = false, productId = '') {
    const { $requiredProductsContainer, $loaderWrapper, $swiperContainer } =
      this.dom;
    if (!hasRequiredItems) return;

    $requiredProductsContainer.style.display = 'block';
    if ($loaderWrapper) $loaderWrapper.style.display = 'block';

    axios({
      method: 'get',
      url: this.config?.endpointFetchRequiredItems
        ? `${this.config?.endpointFetchRequiredItems}?product_id=${productId}`
        : null,
      headers: {
        'content-type': 'application/json'
      }
    })
      .then(response => {
        const { success, body } = response?.data || {};

        if (success) {
          this.requiredItems = body?.requiredItems || [];
          this.renderRequiredProducts();
          if ($swiperContainer) $swiperContainer.style.display = 'block';
          dispatchGenericEvent(constEvent.CART_MODAL_SHOWN);
        } else {
          $requiredProductsContainer.style.display = 'none';
        }
      })
      .catch(error => ($requiredProductsContainer.style.display = 'none'))
      .finally(() => ($loaderWrapper.style.display = 'none'));
  } //loadRequiredItems

  renderRequiredProducts() {
    const { $requiredProductsContainer, $requiredProducts } = this.dom;

    if (!this.requiredItems.length > 3) {
      $requiredProductsContainer.style.display = 'none';
    } else {
      $requiredProductsContainer.style.display = 'block';
      $requiredProducts.innerHTML = this.requiredItems
        .map(this.templates.requiredProduct)
        .join('');
    }
  }
}

export default Module;
